import { useState } from "react";
import { FieldTitle, useInput } from "ra-core";
import {
  FormControl,
  FormError,
  FormField,
  FormLabel,
} from "@/components/admin/form";
import { Input } from "@/components/ui/input";
import { InputHelperText } from "@/components/admin/input-helper-text";

import { validateMaxAttempts } from "./activityTypeForm";

/**
 * Almikia Epic EA (TASK-113): `max_attempts`, an OPTIONAL 1-10 cap -- a
 * plain `<NumberInput>` can't represent "empty" (its `convertStringToNumber`
 * turns a cleared field into `0`, never `null`), so this mirrors
 * `TargetTimeInput.tsx`'s own hand-rolled input for the same reason: an
 * empty field stores `NULL` (no cap), never `0`.
 */
export const AttemptCapInput = ({
  source = "max_attempts",
}: {
  source?: string;
}) => {
  const { id, field, fieldState, isRequired } = useInput({
    source,
    validate: validateMaxAttempts,
  });

  const [displayValue, setDisplayValue] = useState<string>(
    field.value != null ? String(field.value) : "",
  );

  const handleChange = (nextValue: string) => {
    setDisplayValue(nextValue);
    field.onChange(nextValue === "" ? null : Number(nextValue));
  };

  return (
    <FormField id={id} name={field.name}>
      <FormLabel>
        <FieldTitle
          label="resources.deal_activity_types.fields.max_attempts"
          source={source}
          isRequired={isRequired}
        />
      </FormLabel>
      <FormControl>
        <Input
          type="number"
          // No native `min`/`max`/`step`: the browser's own out-of-range
          // block would prevent submit before `validateMaxAttempts` ever
          // runs, so the Spanish `max_attempts_invalid` message (matching
          // the SQL 1-10 check) would never render.
          className="w-24 tabular-nums"
          value={displayValue}
          onChange={(event) => handleChange(event.target.value)}
          onBlur={field.onBlur}
        />
      </FormControl>
      <InputHelperText
        helperText={
          fieldState.error
            ? false
            : "resources.deal_activity_types.fields.max_attempts_help"
        }
      />
      <FormError />
    </FormField>
  );
};
